import * as React from "react";
import { ViewportCalendar as Calendar } from "../ViewportCalendar/ViewportCalendar";
import { DataTable } from "primereact/datatable";

import { CalendarClearFooter } from "../CalendarClearFooter/CalendarClearFooter";
import { ColumnFilterWrapper } from "../ColumnFilterWrapper/ColumnFilterWrapper";
import styles from "./ColumnDateRangeFilter.module.css";

/** PrimeReact Calendar dateFormat — совпадает с constantFormat.calendar порталов */
const CALENDAR_DATE_FORMAT = `dd.mm.yy`;

export interface ColumnDateRangeFilterProps {
  dtRef: React.RefObject<DataTable<any> | null>;
  filters?: any;
  field: string;
  toQueryValue: (range: [Date, Date] | null) => any;
  fromQueryValue?: (persisted: any) => (Date | null)[] | null;
}

export const ColumnDateRangeFilter: React.FC<ColumnDateRangeFilterProps> = ({
  dtRef,
  filters,
  field,
  toQueryValue,
  fromQueryValue,
}) => {
  const [value, setValue] = React.useState<(Date | null)[] | null>(null);
  const filterEntry = filters?.[field];

  React.useEffect(() => {
    const existing = filterEntry?.value;
    if (!existing || !fromQueryValue)
      return;
    const range = fromQueryValue(existing);
    if (range)
      setValue(range);
  }, [filterEntry, field, fromQueryValue]);

  const applyRange = (range: (Date | null)[] | null) => {
    if (!range || (!range[0] && !range[1])) {
      dtRef.current?.filter(toQueryValue(null), field, `custom`);
      return;
    }
    if (range[0] && range[1])
      dtRef.current?.filter(toQueryValue([range[0], range[1]]), field, `custom`);
  };

  const onChange = (e: { value: any }) => {
    const range = e.value as (Date | null)[];
    setValue(range);
    applyRange(range);
  };

  const onClear = () => {
    setValue(null);
    applyRange(null);
  };

  return (
    <ColumnFilterWrapper showClear={!!(value && value[0])} onClear={onClear}>
      <Calendar
        keepInViewport
        className={styles[`filter-daterange`]}
        panelClassName={styles[`filter-panel`]}
        selectionMode="range"
        readOnlyInput
        locale="ru"
        dateFormat={CALENDAR_DATE_FORMAT}
        placeholder="Все"
        value={value as any}
        onChange={onChange}
        appendTo={document.body}
        footerTemplate={() => <CalendarClearFooter onClear={onClear} />} />
    </ColumnFilterWrapper>
  );
};
